import BaseTheme from './BaseTheme';

const B2CTheme = {...BaseTheme};

export default B2CTheme;
